import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useActiveSubstanceDrugContext} from '@/shared/contexts/active-substance-drug'
import {Tabs} from '@chakra-ui/react'

export function HistoryTab() {
  const {activities} = useActiveSubstanceDrugContext()

  return (
    <Tabs.Content value="history">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
